import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import AuthenticationModal from "components/AuthenticationModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { shouldAuthenticate } from "utils/authentication";

interface Props {
  userId: string;
  onDelete: (id: string) => void;
  disabled: boolean;
}

export default function DeleteBtn({ userId, onDelete, disabled }: Props) {
  const { t } = useTranslation("users");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [authIsOpen, setAuthIsOpen] = useState(false);

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleOpen = () => {
    if (shouldAuthenticate()) {
      setAuthIsOpen(true);
    } else {
      setDialogOpen(true);
    }
  };

  const onAuthSuccess = () => {
    setAuthIsOpen(false);
    setDialogOpen(true);
  };

  const handleClickDelete = async () => {
    setDialogOpen(false);
    onDelete(userId);
  };

  const tooltip = disabled ? t("cannotDeleteOwner") : t("common:delete");

  return (
    <>
      <Tooltip title={tooltip}>
        <span>
          <IconButton
            data-testid="users__delete-user-btn"
            onClick={handleOpen}
            disabled={disabled}
            size="small"
            aria-label={t("common:delete")}
          >
            <DeleteOutlinedIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      {dialogOpen && (
        <Dialog open={dialogOpen} onClose={handleClose}>
          <DialogContent>
            <DialogContentText>
              {t("items.deleteConfirmation")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {t("common:no")}
            </Button>
            <Button
              disableElevation
              onClick={handleClickDelete}
              color="primary"
              autoFocus
              variant="contained"
            >
              {t("common:yes")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {authIsOpen && (
        <AuthenticationModal
          isOpen={authIsOpen}
          onSuccess={onAuthSuccess}
          onClose={() => setAuthIsOpen(false)}
        />
      )}
    </>
  );
}
